/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import newSubBucketFolder from '../new-subbucket-folder';
import reBucketTreeView from '../bucket-tree-view';
import removeBucket from '../delete-bucket';
import renameBucketname from '../rename-bucket';

export default {
  name: 'sub-bucket-tree-view',
  components: {
    'new-sub-bucket-folder' : newSubBucketFolder,
    'rebucket-tree-view' : reBucketTreeView,
    'rename-bucket' : renameBucketname,
    'remove-bucket' : removeBucket
  },
  props: ['subBucketData'],
  data () {
    return {
      bucketListDetails:{},
      bucketListResults:[],
      removeBucketId:'',
      removeBucketPopupState:'',
      updateBucketDetail:'',
      updateBucketPopupState:'',
      newSubBucketFolderPopupState:'',
      newSubBucketFolderId:'',
      subBucketList:''
    }
  },
  computed: {
    ...mapGetters([
      'getBucketListOfAwerackGetters',
    ]),
    getBucketListDetailsFun(){
      this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
      return
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails != undefined){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  },
  mounted () {
    this.subBucketList = this.subBucketData
    this.getBucketListDetailsFun
    this.setIntialStateOfBucket
    bus.$on('newSubBucketFolderPopupStateBus', (data) => {
      this.newSubBucketFolderPopupState = data;
    });
    bus.$on('removeBucketPopupStateBus', (data) => {
      this.removeBucketPopupState = data;
    });
    bus.$on('updateBucketPopupStateBus', (data) => {
      this.updateBucketPopupState = data;
    });
  },
  methods: {
    bucketDetailRouting(bucketID){
      if (bucketID != this.$route.params.bucketId) {
        this.$router.push({ name: 'bucketDetails', params: { bucketId: bucketID } })
        this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: bucketID }).then((res) => {
        }).catch((err) => {
        })
      }
    },
    removeBucketPopupOpenMethod(itemId){
      this.removeBucketId = itemId
      this.removeBucketPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    openRenameBucketPopup(data){
      this.updateBucketDetail = data
      this.updateBucketPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    addNewSubBucketFolderMethod(id){
      this.newSubBucketFolderPopupState = true
      this.newSubBucketFolderId = id
      $('body').addClass('body_right_scroll_remove')
    }
  },
  watch:{
    getBucketListDetailsFun(){
      return this.$store.getters.getResearchGroupForAwerackGetters
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails != undefined){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  }
}